
import { BiUser, BiIdCard, BiEnvelope, BiPhone, BiMapPin, BiCopy, BiCalendar, BiDetail, BiBuilding, BiCheckCircle } from 'react-icons/bi';
import { useState } from 'react';
import './style.css';
import { getThirdById } from '../../../usecases/thirds-usecase';
import Modal from '../../atoms/modal/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import LoadingView from '../../pages/loading/loading-view';

const ShowThird = ({ id, data = undefined }) => {
    const [third, SetThird] = useState(undefined);

    const thirdId = typeof data === 'object'
        ? (data?.third_id || data?.id || data?.tercero?.third_id || data?.tercero?.id)
        : data;

    const thirdName = typeof data === 'object'
        ? (data?.third_name || data?.tercero?.third_name || data?.tercero?.name || data?.tercero?.tercero?.name || data?.third?.name || data?.name || (thirdId ? `Tercero #${thirdId}` : 'Proveedor General'))
        : (data ? `Tercero #${data}` : 'Proveedor General');


    const modalId = (id || 'showthird') + '-' + (thirdId || 'none');

    function handleOpenModal() {
        if (!thirdId) return;
        dispatchCustomEvent('modal' + modalId, { eventKey: modalId });

        const resolveThirdObject = (obj) => {
            if (!obj || typeof obj !== 'object') return null;
            if (obj.tercero && typeof obj.tercero === 'object' && (obj.tercero.identification || obj.tercero.email || obj.tercero.phone || obj.tercero.address)) {
                return obj.tercero;
            }
            if (obj.third && typeof obj.third === 'object' && (obj.third.identification || obj.third.email || obj.third.phone || obj.third.address)) {
                return obj.third;
            }
            if (obj.identification || obj.email || obj.phone || obj.address) {
                return obj;
            }
            return null;
        };

        const existingThird = resolveThirdObject(data) || resolveThirdObject(data?.tercero) || resolveThirdObject(data?.third);
        if (existingThird) {
            SetThird(existingThird);
            return;
        }

        SetThird(undefined);
        getThirdById(thirdId).then((res) => {
            if (!res || Object.keys(res || {}).length === 0) {
                dispatchCustomEvent("popup", { message: "Error cargando el tercero", type: "error" });
            } else {
                SetThird(resolveThirdObject(res) || res);
            }
        }).catch(error => {
            console.log(error);
        });
    }



    const copyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            dispatchCustomEvent("popup", { message: "Copiado al portapapeles", type: "success" });
        }).catch(err => {
            console.error('Error al copiar: ', err);
        });
    };

    const InfoRow = ({ icon: Icon, label, value, showCopy = true }) => {
        if (!value) return null;
        return (
            <div className="info-row">
                <div className="info-left">
                    <Icon className="info-icon" />
                    <span className="info-label">{label}:</span>
                    <span className="info-value">{value}</span>
                </div>
                {showCopy && (
                    <button className="copy-btn" onClick={() => copyToClipboard(value)} title="Copiar">
                        <BiCopy />
                    </button>
                )}
            </div>
        );
    };

    return (
        <div className="show-third-container" style={{ display: 'inline-block' }}>
            <span
                className="clickable-third-name"
                onClick={handleOpenModal}
                style={{
                    color: thirdId ? 'var(--color-primary, #65c9b8)' : 'var(--color-text, inherit)',
                    fontWeight: '600',
                    cursor: thirdId ? 'pointer' : 'default',
                    fontSize: '0.88rem',
                    textDecoration: 'none',
                    transition: 'color 0.2s, opacity 0.2s',
                }}
            >
                {thirdName}
            </span>

            {thirdId && (
                <Modal id={modalId} width="fit-content" style={{ maxWidth: '95vw', maxHeight: '95vh' }}>
                    {third === undefined ? (
                        <LoadingView />
                    ) : (
                        <div className="third-detail-card">
                            <div className="third-header">
                                <div className="avatar-container">
                                    <BiUser className="avatar-icon" />
                                </div>
                                <h2 className="third-name">{third.name || third.third_name || thirdName}</h2>

                            </div>

                            <div className="third-info-list scroll-area">
                                <InfoRow icon={BiIdCard} label="Documento" value={third.identification} />
                                <InfoRow icon={BiEnvelope} label="Email" value={third.email} />
                                <InfoRow icon={BiPhone} label="Teléfono" value={third.phone} />
                                <InfoRow icon={BiMapPin} label="Dirección" value={third.address} />
                                <InfoRow icon={BiBuilding} label="Zona Postal" value={third.postalZoneCode} />
                                <InfoRow icon={BiDetail} label="Reg. Mercantil" value={third.merchantRegistration} />
                                <InfoRow icon={BiCheckCircle} label="Estado" value={third.status} showCopy={false} />

                                <div className="roles-tags">
                                    {third.client && <span className="role-tag client">Cliente</span>}
                                    {third.provider && <span className="role-tag provider">Proveedor</span>}
                                    {third.other && <span className="role-tag other">Otro</span>}
                                </div>

                                {third.createdAt && (
                                    <div className="meta-info">
                                        <BiCalendar />
                                        <span>Registrado el: {new Date(third.createdAt).toLocaleDateString()}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Modal>
            )}
        </div>
    );
};

export default ShowThird;

